import camelcaseKeys from 'camelcase-keys';
import CallsAPI from 'dashboard/api/calls';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export const initialState = {
  records: [],
  meta: { count: 0, currentPage: 1, totalPages: 0 },
  uiFlags: { isFetching: false },
  fetchRequestToken: 0,
};

export const getters = {
  getRecords: state => state.records,
  getMeta: state => state.meta,
  getUIFlags: state => state.uiFlags,
};

export const mutations = {
  setRecords(state, records) {
    state.records = records;
  },
  setMeta(state, meta) {
    state.meta = meta;
  },
  setFetching(state, isFetching) {
    state.uiFlags.isFetching = isFetching;
  },
  incrementFetchRequestToken(state) {
    state.fetchRequestToken += 1;
  },
  resetResults(state) {
    state.records = [];
    state.meta = { count: 0, currentPage: 1, totalPages: 0 };
  },
};

export const actions = {
  async fetchCalls({ commit, state }, params = {}) {
    commit('setFetching', true);
    commit('incrementFetchRequestToken');
    const requestToken = state.fetchRequestToken;

    try {
      const { data } = await CallsAPI.get(params);
      if (state.fetchRequestToken !== requestToken) return state.records;

      commit('setRecords', camelcaseKeys(data.payload, { deep: true }));
      commit('setMeta', camelcaseKeys(data.meta));
      return state.records;
    } catch (error) {
      if (state.fetchRequestToken !== requestToken) return state.records;

      commit('resetResults');
      return throwErrorMessage(error);
    } finally {
      if (state.fetchRequestToken === requestToken) {
        commit('setFetching', false);
      }
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};
